/**
 * Central configuration for NEURA AI.
 * Handles environment-specific URLs for deployment (Vercel, HuggingFace, etc.)
 */
declare var process: any;

const getMCPBaseUrl = () => {
  // Priority 1: Vercel/Parcel process.env
  if (typeof process !== 'undefined' && process.env && process.env.VITE_MCP_URL) {
    return process.env.VITE_MCP_URL;
  }
  // Priority 2: Vite import.meta.env
  if ((import.meta as any).env?.VITE_MCP_URL) {
    return (import.meta as any).env.VITE_MCP_URL;
  }
  
  // Return the deployed HuggingFace URL
  return 'https://karthic07-neura-mcp.hf.space';
};

export const MCP_BASE_URL = getMCPBaseUrl();

export const isDev = (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') || (import.meta as any).env?.DEV;

console.log(`[Config] MCP_BASE_URL set to: ${MCP_BASE_URL}`);
